import { render, staticRenderFns } from "./editConfiguration.vue?vue&type=template&id=e353a85c"
import script from "./editConfiguration.vue?vue&type=script&lang=js"
export * from "./editConfiguration.vue?vue&type=script&lang=js"
import style0 from "./editConfiguration.vue?vue&type=style&index=0&id=e353a85c&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e353a85c')) {
      api.createRecord('e353a85c', component.options)
    } else {
      api.reload('e353a85c', component.options)
    }
    module.hot.accept("./editConfiguration.vue?vue&type=template&id=e353a85c", function () {
      api.rerender('e353a85c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qualityService/signLimitConfiguration/component/editConfiguration.vue"
export default component.exports